<template>
  <div class="wrapper">
    <GenericButton
      v-for="profession in professions"
      :key="profession"
      :title="getProfessionData(profession).title"
      :disabled="getProfessionData(profession).level === 2 || !getProfessionData(profession).available"
      @click="tagProfession(profession)"
      :image-src="require(`@/assets/img/professions/${getProfessionData(profession).image}.png`)"
      :active-level="getProfessionData(profession).level"
      :is-active="!!getProfessionData(profession).level"
      width="55px"
      height="30px"
      image-width="30px"
    />
  </div>
</template>
<script>
import { useStore } from 'vuex';
import GenericButton from '../shared/GenericButton.vue';
export default {
    name: 'Professions',
    setup() {
        const store = useStore();
        const professions = ['SmallGuns', 'BigGuns', 'EnergyExpert', 'DemolitionExpert', 'Armorer', 'Doctor']
        const getProfessionData = (profession) => {
            const data = {
                level: +store.state.build.Professions[profession + 1].tagged + +store.state.build.Professions[profession + 2].tagged,
                available: store.state.build.Professions[profession + 1].available || store.state.build.Professions[profession + 2].available,
                image: store.state.build.Professions[profession + 1].tagged ? `${profession}2` : `${profession}1`,
                title: store.state.build.Professions[profession + 1].tagged ? store.state.build.Professions[profession + 2].name : store.state.build.Professions[profession + 1].name,
            };
            return data;
        };
        const tagProfession = (profession) => {
            const postfix = store.state.build.Professions[profession + 1].available
                ?
                    '1'
                :
                    store.state.build.Professions[profession + 2].available
                        ?
                            '2'
                        :
                            '0';
            if (+postfix) {
                const data = {
                    profession: profession + postfix
                };
                store.dispatch('handleIncomingCommand', {
                    command: 'takeProfession',
                    data: data
                });
            }
            else {
                return;
            }
        };
        return {
            state: store.state,
            professions,
            getProfessionData,
            tagProfession
        };
    },
    components: { GenericButton }
};
</script>
<style scoped>
.wrapper {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  row-gap: 2px;
  margin-top: 4px;
}
</style>